
import { gql } from "@apollo/client";
import { ApiService } from "./ApiService";
import { OpResult } from "@sdflc/api-helpers";

// ─── GraphQL Query ────────────────────────────────────────────────────────────

const CONTENT_BLOCK_DYNAMIC_CONTENT_QUERY_GET = gql`
  query ContentBlockDynamicContentGet($params: ContentBlockDynamicContentInput!) {
    contentBlockDynamicContentGet(params: $params) {
      code
      data {
        contentBlockId
        contentType
        items
        meta
        nextCursor
        hasMore
      }
      errors {
        name
        errors
        warnings
      }
    }
  }
`;

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ContentBlockDynamicContent {
  contentBlockId: string;
  contentType: string;
  items: string;       // JSON string — parse based on contentType
  meta: string;        // JSON string — parse based on contentType
  nextCursor: string | null;
  hasMore: boolean;
}

export interface ContentBlockDynamicContentInput {
  contentBlockId: string;
  cursor?: string | null;
  pageSize?: number | null;
}

// ─── Service ──────────────────────────────────────────────────────────────────

export class ContentBlockDynamicService {
  /**
   * Fetch dynamic content for a content block.
   * Pass cursor from a previous response to get the next page.
   * Omit cursor to start from the beginning.
   */
  static async getDynamicContent(
    params: ContentBlockDynamicContentInput
  ): Promise<OpResult> {
    const result = await ApiService.executeQuery(
      CONTENT_BLOCK_DYNAMIC_CONTENT_QUERY_GET,
      { params }
    );
    return result;
  }
}